import { useState } from "react";

const faqs = [
  {
    category: "가입 & 시작",
    icon: "ri-user-add-line",
    color: "violet",
    items: [
      {
        q: "회원가입은 어떻게 하나요?",
        a: "Signal SMS 홈페이지에서 '무료로 시작하기' 버튼을 클릭하면 됩니다. 이메일 인증만으로 5분 이내에 가입이 완료되며, 별도의 서류 제출 없이 즉시 서비스를 이용할 수 있습니다.",
      },
      {
        q: "가입 후 바로 문자를 발송할 수 있나요?",
        a: "네, 가입 즉시 발송이 가능합니다. 다만 발신번호 등록이 필요하며, 발신번호 등록은 통신사 인증을 통해 약 10분 내로 완료됩니다. 등록 후 바로 발송을 시작하실 수 있습니다.",
      },
      {
        q: "무료 체험이 가능한가요?",
        a: "신규 가입 시 소량의 무료 발송 크레딧을 제공합니다. 실제 서비스를 직접 체험해보신 후 충전하여 사용하실 수 있습니다. 별도의 신용카드 등록 없이 무료로 시작 가능합니다.",
      },
    ],
  },
  {
    category: "결제 & 요금",
    icon: "ri-secure-payment-line",
    color: "pink",
    items: [
      {
        q: "요금은 어떻게 청구되나요?",
        a: "선불 충전 방식으로 운영됩니다. 원하는 금액만큼 충전 후 사용한 만큼만 차감됩니다. 월정액이나 약정 없이 자유롭게 이용하실 수 있으며, 잔액은 언제든지 환불 신청이 가능합니다.",
      },
      {
        q: "충전 방법은 무엇이 있나요?",
        a: "신용카드, 체크카드, 계좌이체, 가상계좌 등 다양한 결제 수단을 지원합니다. 법인 고객의 경우 세금계산서 발행도 가능하며, 대량 이용 시 별도 단가 협의가 가능합니다.",
      },
      {
        q: "대량 발송 시 할인이 있나요?",
        a: "월 발송량에 따라 단계별 할인 혜택을 제공합니다. 월 10만 건 이상 발송 시 별도 단가 협의가 가능하며, 자세한 내용은 고객센터로 문의해 주시면 맞춤 견적을 안내해 드립니다.",
      },
    ],
  },
  {
    category: "API 연동",
    icon: "ri-code-s-slash-line",
    color: "fuchsia",
    items: [
      {
        q: "API 연동은 어떻게 하나요?",
        a: "회원가입 후 대시보드에서 API 키를 발급받아 사용하시면 됩니다. RESTful API 방식으로 제공되며, Python, Java, PHP, Node.js 등 주요 언어별 SDK와 상세한 예제 코드가 포함된 문서를 제공합니다.",
      },
      {
        q: "API 연동 시 발송 속도는 어떻게 되나요?",
        a: "API 호출 후 평균 0.3초 이내에 발송이 완료됩니다. 대량 발송의 경우 초당 최대 1,000건까지 처리 가능하며, 더 높은 처리량이 필요한 경우 별도 협의를 통해 확장이 가능합니다.",
      },
      {
        q: "발송 결과를 API로 받을 수 있나요?",
        a: "네, 웹훅(Webhook) 방식으로 발송 결과를 실시간으로 수신할 수 있습니다. 성공, 실패, 수신 확인 등 상세한 상태 정보를 지정한 URL로 즉시 전달해 드립니다.",
      },
    ],
  },
  {
    category: "발송 & 기능",
    icon: "ri-message-3-line",
    color: "violet",
    items: [
      {
        q: "SMS, LMS, MMS의 차이는 무엇인가요?",
        a: "SMS는 70자 이내의 단문 메시지, LMS는 2,000자 이내의 장문 메시지, MMS는 이미지나 파일을 첨부할 수 있는 멀티미디어 메시지입니다. 내용 길이와 첨부 여부에 따라 자동으로 구분되어 발송됩니다.",
      },
      {
        q: "예약 발송은 어떻게 설정하나요?",
        a: "발송 화면에서 '예약 발송' 옵션을 선택하고 원하는 날짜와 시간을 지정하면 됩니다. 최대 1년 후까지 예약이 가능하며, 예약 취소 및 수정도 발송 전까지 자유롭게 가능합니다.",
      },
      {
        q: "발송 실패 시 어떻게 처리되나요?",
        a: "발송 실패 건은 자동으로 재발송을 시도하며, 최종 실패 시 해당 건의 요금은 차감되지 않습니다. 실패 원인(수신 거부, 번호 오류 등)은 대시보드에서 상세하게 확인하실 수 있습니다.",
      },
    ],
  },
];

const colorMap: Record<string, { badge: string; icon: string; dot: string; border: string }> = {
  violet: {
    badge: "bg-violet-500/15 text-violet-300 border-violet-500/25",
    icon: "text-violet-400",
    dot: "bg-violet-500",
    border: "border-violet-500/30",
  },
  pink: {
    badge: "bg-pink-500/15 text-pink-300 border-pink-500/25",
    icon: "text-pink-400",
    dot: "bg-pink-500",
    border: "border-pink-500/30",
  },
  fuchsia: {
    badge: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/25",
    icon: "text-fuchsia-400",
    dot: "bg-fuchsia-500",
    border: "border-fuchsia-500/30",
  },
};

export default function FaqSection() {
  const [openKey, setOpenKey] = useState<string | null>("0-0");

  const toggle = (key: string) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  return (
    <section id="faq" className="bg-[#0a0a18] py-24 px-6 relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-violet-500/30 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-pink-500/20 to-transparent" />
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-violet-900/10 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-5xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-violet-400 text-xs font-semibold tracking-widest uppercase mb-3 block">
            FAQ
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            자주 묻는{" "}
            <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">
              질문
            </span>
          </h2>
          <p className="text-gray-400 text-base max-w-lg mx-auto">
            궁금한 점이 있으신가요? 아래에서 빠르게 답변을 확인하세요.
          </p>
        </div>

        {/* FAQ groups */}
        <div className="space-y-10">
          {faqs.map((group, gi) => {
            const c = colorMap[group.color];
            return (
              <div key={group.category}>
                {/* Category label */}
                <div className="flex items-center gap-3 mb-4">
                  <span
                    className={`inline-flex items-center gap-2 border text-xs font-semibold px-3 py-1.5 rounded-full ${c.badge}`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${group.icon} text-xs`}></i>
                    </div>
                    {group.category}
                  </span>
                  <div className="flex-1 h-px bg-white/[0.06]" />
                </div>

                {/* Items */}
                <div className="space-y-3">
                  {group.items.map((item, ii) => {
                    const key = `${gi}-${ii}`;
                    const isOpen = openKey === key;
                    return (
                      <div
                        key={key}
                        className={`rounded-xl border transition-all duration-300 overflow-hidden ${
                          isOpen
                            ? `${c.border} bg-white/[0.05]`
                            : "border-white/[0.07] bg-white/[0.02] hover:border-white/15 hover:bg-white/[0.04]"
                        }`}
                      >
                        <button
                          onClick={() => toggle(key)}
                          className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                        >
                          <div className="flex items-center gap-3">
                            <div
                              className={`w-1.5 h-1.5 rounded-full shrink-0 transition-all duration-300 ${
                                isOpen ? c.dot : "bg-white/20"
                              }`}
                            />
                            <span
                              className={`font-medium text-sm md:text-base transition-colors duration-200 ${
                                isOpen ? "text-white" : "text-gray-300"
                              }`}
                            >
                              {item.q}
                            </span>
                          </div>
                          <div
                            className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-all duration-300 ${
                              isOpen
                                ? "bg-violet-500/20 text-violet-300 rotate-45"
                                : "bg-white/5 text-gray-500"
                            }`}
                          >
                            <i className="ri-add-line text-base"></i>
                          </div>
                        </button>

                        {/* Answer */}
                        <div
                          className={`transition-all duration-300 ease-in-out overflow-hidden ${
                            isOpen ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
                          }`}
                        >
                          <div className="px-6 pb-5 pl-[3.25rem]">
                            <p className="text-gray-400 text-sm leading-relaxed">{item.a}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-14 text-center bg-white/[0.03] border border-white/[0.08] rounded-2xl px-8 py-10">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-violet-500/30 to-pink-500/30 mx-auto mb-4">
            <i className="ri-customer-service-2-line text-violet-300 text-xl"></i>
          </div>
          <h3 className="text-white font-bold text-lg mb-2">원하는 답변을 찾지 못하셨나요?</h3>
          <p className="text-gray-400 text-sm mb-6">
            고객센터로 문의하시면 빠르게 도움을 드리겠습니다. 평균 응답 시간 5분 이내.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://t.me/signal_sms"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto bg-gradient-to-r from-violet-600 to-pink-600 hover:from-violet-500 hover:to-pink-500 text-white px-6 py-2.5 rounded-lg font-semibold text-sm transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-2 justify-center"
            >
              <i className="ri-telegram-line"></i>
              1:1 텔레그램 문의
            </a>
            <button className="w-full sm:w-auto border border-white/15 hover:border-white/30 text-gray-300 hover:text-white px-6 py-2.5 rounded-lg font-medium text-sm transition-all hover:bg-white/5 cursor-pointer whitespace-nowrap flex items-center gap-2 justify-center">
              <i className="ri-mail-line"></i>
              이메일 문의
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}